<template>
  <div>
    <Table border :columns="columns1" :data="data1"></Table>
  </div>
</template>

<script>
import { getCondition } from "@api/user";
export default {
  name: "VerifyCenter",
  data() {
    return {
      columns1: [
        {
          type: "index",
          width: 60,
          align: "center"
        },
        {
          title: "提交时间",
          key: "add_time",
          align: "center"
        },
        {
          title: "申请的类型",
          key: "type",
          align: "center"
        },
        {
          title: "审核结果",
          key: "result",
          align: "center"
        },
        {
          title: "原因",
          key: "remark",
          align: "center"
        }
      ],
      data1: [],
      params: {
        page: 1
      }
    };
  },
  created() {
    getCondition(this.params).then(res => {
      res.data.sertification.forEach(item => {
        item.add_time = this.formatDate(item.add_time);
        item.type = item.type === 1 ? "企业认证" : "个人认证";
        if (item.isAgree === 1) {
          item.result = "审核通过";
        } else if (item.isAgree === 2) {
          item.result = "审核中";
        } else {
          item.result = "审核不通过";
        }
        this.data1.push(item);
      });
    });
  },
  methods: {
    formatDate(value) {
      const date = new Date(value * 1000);
      const y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m;
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s;
    }
  }
};
</script>

<style></style>
